import React from "react";
import gql from "graphql-tag";
import { navigate } from "@reach/router";
import { constants } from "@services";
import { Box, Text } from "@atoms";
import { useStoreAppValue } from "@hooks";
import { BrandModalGiftcardLink } from "../BrandModalGiftcardLink";
import { BrandModalShopLink } from "../BrandModalShopLink";
import { BrandModalInStoreLink } from "../BrandModalInStoreLink";
import { BrandModalLinksFragment } from "./__generated__/BrandModalLinksFragment";

// == Types ================================================================

interface IProps {
  brand: BrandModalLinksFragment;
  location?: $FixMe;
  tinyLinkKey?: string;
}

// == Constants ============================================================

const FRAGMENTS = {
  fields: gql`
    fragment BrandModalLinksFragment on Brand {
      id
      nearestLocation {
        id
        hasLinkedCard
      }
      shopLink {
        id
        ...BrandModalShopLinkFragment
      }
      giftcardLink {
        id
        ...BrandModalGiftcardLinkFragment
      }
      linkedCardLink {
        id
        ...BrandModalInStoreLinkFragment
      }
    }
    ${BrandModalShopLink.fragments.fields}
    ${BrandModalGiftcardLink.fragments.fields}
    ${BrandModalInStoreLink.fragments.fields}
  `,
};

// == Component ============================================================

const BrandModalLinks = ({ brand, location, tinyLinkKey }: IProps) => {
  const {
    featureFlags: { newCollection },
  } = useStoreAppValue();

  const { shopLink, giftcardLink, linkedCardLink } = brand;
  const navigateToLink = (linkId: string, locationId?: string) => {
    const brandRoute = `?${constants.brandParam}=${brand.id}`;
    let navigationRoute = `?${constants.linkParam}=${linkId}`;
    if (locationId) {
      navigationRoute += `&location_id=${locationId}`;
      navigate(navigationRoute, {
        state: { brandRoute, tinyLinkKey, brandId: brand.id, canReturn: true },
      });
    }
    navigate(navigationRoute, {
      state: { brandRoute, tinyLinkKey, brandId: brand.id, canReturn: true },
    });
  };

  const hasLinkedCardLink = !!linkedCardLink && !!location && location.hasLinkedCard;

  if (!brand) return null;
  return (
    <>
      {!!shopLink && (
        <Box key={shopLink.id}>
          <BrandModalShopLink isFirst link={shopLink} onClick={navigateToLink} />
        </Box>
      )}
      {!!giftcardLink && (
        <Box key={giftcardLink.id}>
          <BrandModalGiftcardLink
            isFirst={!shopLink}
            link={giftcardLink}
            onClick={navigateToLink}
          />
        </Box>
      )}
      {!!newCollection && !!hasLinkedCardLink && (
        <Box key={linkedCardLink.id}>
          <BrandModalInStoreLink
            isFirst={!!(!shopLink && !giftcardLink)}
            link={linkedCardLink}
            locationId={location.id}
            onClick={navigateToLink}
          />
        </Box>
      )}
      {!shopLink && !giftcardLink && !hasLinkedCardLink && !!newCollection && (
        <Box textAlign="center">
          <Text as="p">There are no offers available at this time.</Text>
        </Box>
      )}
    </>
  );
};

BrandModalLinks.fragments = FRAGMENTS;
export default BrandModalLinks;

// == Styles ===============================================================
